import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface StatisticalService {
  name: string;
  api_token: string;
}

export interface StatisticalServiceInfo {
  errors: unknown;
  listStatisticalService: StatisticalService;
  isAuthenticated: boolean;
}

@Module
export default class StatisticalServiceModule
  extends VuexModule
  implements StatisticalServiceInfo
{
  errors = {};
  listStatisticalService = {} as StatisticalService;
  serviceStatisticalDetail = {};
  isAuthenticated = !!JwtService.getToken();

  get getListStatisticalService() {
    return this.listStatisticalService;
  }

  get getStatisticalServiceDetail() {
    return this.serviceStatisticalDetail;
  }

  @Mutation
  [Mutations.STATISTICAL_SERVICE_LIST_DATA](listStatisticalService) {
    this.listStatisticalService = listStatisticalService;
  }

  @Mutation
  [Mutations.STATISTICAL_SERVICE_DETAIL_DATA](serviceStatisticalDetail) {
    this.serviceStatisticalDetail = serviceStatisticalDetail;
  }

  @Action
  [Actions.STATISTICAL_SERVICE_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/statistical_services", payload)
        .then((data) => {
          this.context.commit(Mutations.STATISTICAL_SERVICE_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.STATISTICAL_SERVICE_DETAIL](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(`/statistical_services/${payload.id}/detail`)
        .then((data) => {
          this.context.commit(Mutations.STATISTICAL_SERVICE_DETAIL_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.STATISTICAL_SERVICE_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(
        `statistical_services/${payload.id}/delete`,
        payload
      )
        .then((res) => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.STATISTICAL_SERVICE_UPSERT](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      const idPath = payload.get("id") ? `/${payload.get("id")}` : "";
      return ApiService.post(`statistical_services/upsert${idPath}`, payload)
        .then(() => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }
}
